import React, { useEffect, useRef, useState } from 'react';

import { styled } from '@mui/material/styles';
import { StyledButton } from '../DS_ButtonLink/DS_ButtonLinkStyles.jsx';
import translationsToggleButton from './data/translationsToggleButton';

const ToggleButton = ({ isContentExpandedState, contentHeight, hoveredContainerHeight }) => {
  const dataToggleButtonTranslations = translationsToggleButton[process.env.GATSBY_COUNTRY_CODE];
  const { showMore, showLess } = dataToggleButtonTranslations;
  const [isContentExpanded, setIsContentExpanded] = isContentExpandedState;
  const moreButtonRef = useRef(null);
  const [moreButtonBottomPosition, setMoreButtonBottomPosition] = useState(null);

  useEffect(() => {
    if (!contentHeight || !moreButtonRef?.current) return;
    const positionBottom = moreButtonRef.current?.getBoundingClientRect()?.bottom;

    if (!positionBottom) return;

    setMoreButtonBottomPosition(positionBottom);
  }, [contentHeight]);

  const toggleContent = () => {
    // scroll to the "MoreButton" when collapsing the content
    if (moreButtonBottomPosition && isContentExpanded && window !== 'undefined')
      window.scrollTo(0, moreButtonBottomPosition - hoveredContainerHeight);

    setIsContentExpanded(prevState => !prevState);
  };

  return (
    <StyledWrapperButton>
      <StyledButton variant="outlined" isSizeBig={true} onClick={toggleContent} ref={moreButtonRef}>
        {isContentExpanded ? showLess : showMore}
      </StyledButton>
    </StyledWrapperButton>
  );
};

export default ToggleButton;

export const StyledWrapperButton = styled('div')(
  ({ theme }) => `
  display: flex; 
  justify-content: center;
   margin: ${theme.DS_spacing(['sm'])} 0 ${theme.DS_spacing(['xl'])};
`,
);
